import EmailFooterV2 from '../components/FooterV2';

interface EmailProps {
  userName: string
  courseName: string
  courseDate: string
  courseDuration: string
  instructor: string
  modality: string
  courseId: string
  session: string
  time: string
  address: string
  companyName: string
  cancellationReason: string
  refundInfo?: string
  rescheduleLink?: string
  supportEmail?: string
  supportPhone?: string
}

export default function ClassCancellationNotificationEmail({
  userName = "João Silva",
  courseName = "Fundamentos de Data Analytics",
  courseDate = "15 de abril de 2025",
  courseDuration = "120 minutos",
  instructor = "Ana Carolina Soares",
  modality = "Híbrido",
  courseId = "FA-2025-001",
  session = "1ª aula",
  time = "06:00 às 14:00",
  address = "Av. Paulista, 1000 - Sala 203, São Paulo - SP",
  companyName = "Empresa XYZ Ltda",
  cancellationReason = "Indisponibilidade do instrutor por motivos de saúde",
  refundInfo = "O valor será estornado automaticamente em até 5 dias úteis",
  rescheduleLink = "https://trivium.com.br/reagendar",
  supportEmail = "suporte@trivium.com.br",
  supportPhone = "(11) 3181-5940",
}: EmailProps) {
  return (
    <div style={{ margin: 0, padding: 0, fontFamily: "Arial, sans-serif", backgroundColor: "#ffffff" }}>
      {/* Responsive CSS Styles */}
      <style dangerouslySetInnerHTML={{
        __html: `
          @media only screen and (max-width: 600px) {
            .email-container { width: 100% !important; max-width: 100% !important; border-radius: 0 !important; }
            .body-content { padding: 24px 20px !important; }
            .header { padding: 16px !important; }
            .logo { width: 100px !important; }
            .title { font-size: 20px !important; margin: 12px 0 4px !important; }
            .subtitle { font-size: 14px !important; margin: 0 0 20px !important; }
            .badge { font-size: 12px !important; padding: 6px 12px !important; }
            .card { padding: 12px !important; margin-bottom: 6px !important; }
            .card-label { font-size: 11px !important; }
            .card-value { font-size: 14px !important; }
            .section-title { font-size: 16px !important; margin: 20px 0 8px !important; }
            .info-box { padding: 16px !important; }
            .info-box h3 { font-size: 15px !important; }
            .info-box p { font-size: 13px !important; }
            .info-list { font-size: 13px !important; }
            .btn { display: block !important; width: 100% !important; text-align: center !important; margin-bottom: 8px !important; }
            .btn-primary { padding: 14px 16px !important; font-size: 15px !important; }
            .list, .warning-list { font-size: 13px !important; padding-left: 16px !important; }
            .contact-box { padding: 16px !important; }
            .contact-title { font-size: 15px !important; }
            .contact-info { font-size: 13px !important; }
            .footer { padding: 20px 16px !important; }
            .footer-logo { width: 70px !important; }
            .social-icons { justify-content: center !important; gap: 20px !important; }
            .social-icon { width: 24px !important; height: 24px !important; }
            .cancellation-highlight { padding: 12px !important; }
            .reason-box { padding: 12px !important; }
          }
          @media only screen and (max-width: 480px) {
            .body-content { padding: 20px 16px !important; }
            .title { font-size: 18px !important; }
            .subtitle { font-size: 13px !important; }
            .card { padding: 10px !important; }
            .card-label { font-size: 10px !important; }
            .card-value { font-size: 13px !important; }
            .section-title { font-size: 15px !important; }
            .info-box { padding: 14px !important; }
            .btn-primary { padding: 12px 14px !important; font-size: 14px !important; }
            .social-icons { gap: 16px !important; }
            .social-icon { width: 22px !important; height: 22px !important; }
            .cancellation-highlight { padding: 10px !important; }
            .reason-box { padding: 10px !important; }
          }
        `
      }} />
      
      <table
        width="100%"
        border={0}
        cellSpacing={0}
        cellPadding={0}
        style={{ backgroundColor: "#ffffff", padding: "40px 0" }}
      >
        <tbody>
          <tr>
            <td align="center">
              <table
                className="email-container"
                width={600}
                border={0}
                cellSpacing={0}
                cellPadding={0}
                style={{ 
                  backgroundColor: "#FAFAFA", 
                  borderRadius: "12px", 
                  overflow: "hidden",
                  maxWidth: "600px",
                  margin: "0 auto"
                }}
              >
                <tbody>
                  {/* Header */}
                  <tr>
                    <td 
                      className="header"
                      align="center" 
                      style={{ 
                        backgroundColor: "#1F1746", 
                        padding: "20px",
                        textAlign: "center"
                      }}
                    >
                      <div style={{ textAlign: "center", width: "100%" }}>
                        <img
                          className="logo"
                          src="https://asset.brandfetch.io/idNdb_MPJ2/idFGj2lq6u.png?c=1dxbfHSJFAPEGdCLU4o5B"
                          alt="Logo Trivium"
                          width={120}
                          style={{ 
                            display: "block", 
                            width: "120px", 
                            height: "auto",
                            margin: "0 auto"
                          }}
                        />
                      </div>
                    </td>
                  </tr>

                  {/* Body */}
                  <tr>
                    <td 
                      className="body-content"
                      style={{ 
                        padding: "36px 30px", 
                        color: "#333333"
                      }}
                    >
                      {/* Badge + Title */}
                      <div style={{ textAlign: "center" }}>
                        <span
                          className="badge"
                          style={{
                            backgroundColor: "#fee2e2",
                            color: "#dc2626",
                            display: "inline-block",
                            padding: "8px 16px",
                            borderRadius: "999px",
                            fontSize: "13px",
                            fontWeight: 700,
                            marginBottom: "16px"
                          }}
                        >
                          ❌ Formação Cancelada
                        </span>
                        <h1 
                          className="title"
                          style={{ 
                            fontSize: "24px", 
                            margin: "16px 0 6px", 
                            color: "#111111",
                            lineHeight: "1.3"
                          }}
                        >
                          Olá, {userName} 👋
                        </h1>
                        <p 
                          className="subtitle"
                          style={{ 
                            fontSize: "16px", 
                            margin: "0 0 24px", 
                            color: "#555555", 
                            lineHeight: "1.6"
                          }}
                        >
                          Lamentamos informar o cancelamento da formação
                          <br />
                          <strong>{courseName}</strong>
                        </p>
                      </div>

                      {/* Destaque do Cancelamento */}
                      <div
                        className="cancellation-highlight"
                        style={{
                          background: "linear-gradient(135deg, #fee2e2 0%, #fecaca 100%)",
                          border: "2px solid #ef4444",
                          borderRadius: "12px",
                          padding: "20px",
                          marginBottom: "24px",
                          textAlign: "center"
                        }}
                      >
                        <h2 style={{ 
                          fontSize: "18px", 
                          color: "#dc2626", 
                          margin: "0 0 16px",
                          fontWeight: "bold"
                        }}>
                          ⚠️ Cancelamento da Formação
                        </h2>
                        <p style={{ 
                          fontSize: "14px", 
                          color: "#dc2626", 
                          margin: 0,
                          lineHeight: "1.5"
                        }}>
                          Infelizmente, precisamos cancelar esta formação. Pedimos sinceras desculpas pelo inconveniente.
                        </p>
                      </div>

                      {/* Informações da Formação Cancelada */}
                      <h2 
                        className="section-title"
                        style={{ 
                          fontSize: "18px", 
                          color: "#111", 
                          margin: "24px 0 10px",
                          lineHeight: "1.3"
                        }}
                      >
                        📚 Formação Cancelada
                      </h2>
                      <div
                        className="info-box"
                        style={{
                          border: "1px solid #e5e7eb",
                          borderRadius: "10px",
                          padding: "20px",
                          marginBottom: "16px",
                          backgroundColor: "#f9fafb"
                        }}
                      >
                        <h3 style={{ margin: "0 0 4px", fontSize: "16px", color: "#1F1746" }}>{courseName}</h3>
                        <p style={{ margin: "0 0 14px", fontSize: "14px", color: "#6b7280" }}>Analytics Essentials</p>
                        <table 
                          width="100%" 
                          cellPadding={0} 
                          cellSpacing={0} 
                          className="info-list"
                          style={{ fontSize: "14px", color: "#111" }}
                        >
                          <tbody>
                            <tr>
                              <td style={{ padding: "6px 0", verticalAlign: "top" }}>
                                🔖 <strong>ID da aula:</strong> {courseId}
                              </td>
                            </tr>
                            <tr>
                              <td style={{ padding: "6px 0", verticalAlign: "top" }}>
                                📌 <strong>Sessão:</strong> {session}
                              </td>
                            </tr>
                            <tr>
                              <td style={{ padding: "6px 0", verticalAlign: "top" }}>
                                📅 <strong>Data prevista:</strong> {courseDate}
                              </td>
                            </tr>
                            <tr>
                              <td style={{ padding: "6px 0", verticalAlign: "top" }}>
                                🕓 <strong>Horário previsto:</strong> {time}
                              </td>
                            </tr>
                            <tr>
                              <td style={{ padding: "6px 0", verticalAlign: "top" }}>
                                👨‍🏫 <strong>Instrutor:</strong> {instructor}
                              </td>
                            </tr>
                            <tr>
                              <td style={{ padding: "6px 0", verticalAlign: "top" }}>
                                🌍 <strong>Modalidade:</strong> {modality}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>

                      {/* Motivo do Cancelamento */}
                      <h2 
                        className="section-title"
                        style={{ 
                          fontSize: "18px", 
                          color: "#111", 
                          margin: "24px 0 10px",
                          lineHeight: "1.3"
                        }}
                      >
                        📋 Motivo do Cancelamento
                      </h2>
                      <div
                        className="reason-box"
                        style={{
                          background: "#fffbeb",
                          border: "1px solid #fcd34d",
                          borderRadius: "10px",
                          padding: "18px",
                          marginBottom: "20px"
                        }}
                      >
                        <p style={{ 
                          margin: 0, 
                          fontSize: "14px", 
                          color: "#374151",
                          lineHeight: "1.6"
                        }}>
                          <strong>Motivo:</strong> {cancellationReason}
                        </p>
                      </div>

                      {/* Informações sobre Reembolso */}
                      {refundInfo && (
                        <>
                          <h2 
                            className="section-title"
                            style={{ 
                              fontSize: "18px", 
                              color: "#111", 
                              margin: "24px 0 10px",
                              lineHeight: "1.3"
                            }}
                          >
                            💰 Informações sobre Reembolso
                          </h2>
                          <div
                            className="info-box"
                            style={{
                              background: "#f0fdf4",
                              border: "1px solid #86efac",
                              borderRadius: "10px",
                              padding: "18px",
                              marginBottom: "20px"
                            }}
                          >
                            <p style={{ 
                              margin: 0, 
                              fontSize: "14px", 
                              color: "#374151",
                              lineHeight: "1.6"
                            }}>
                              💳 {refundInfo}
                            </p>
                          </div>
                        </>
                      )}

                      {/* Organização */}
                      <h2 
                        className="section-title"
                        style={{ 
                          fontSize: "18px", 
                          color: "#111", 
                          margin: "24px 0 10px",
                          lineHeight: "1.3"
                        }}
                      >
                        🏢 Organização
                      </h2>
                      <div
                        className="info-box"
                        style={{
                          border: "1px solid #e5e7eb",
                          borderRadius: "10px",
                          padding: "20px",
                          marginBottom: "16px"
                        }}
                      >
                        <h3 style={{ margin: "0 0 6px", fontSize: "15px", color: "#1F1746" }}>{companyName}</h3>
                        <p style={{ margin: 0, fontSize: "13px", color: "#4b5563" }}>
                          🤝 Esta formação era uma iniciativa do {companyName}, em parceria com a Trivium.
                        </p>
                      </div>

                      {/* Próximos passos */}
                      <h2 
                        className="section-title"
                        style={{ 
                          fontSize: "18px", 
                          color: "#111", 
                          margin: "24px 0 10px",
                          lineHeight: "1.3"
                        }}
                      >
                        📝 Próximos Passos
                      </h2>
                      <div
                        className="info-box"
                        style={{
                          border: "1px solid #e5e7eb",
                          borderRadius: "10px",
                          padding: "20px",
                          marginBottom: "16px"
                        }}
                      >
                        <ul
                          className="list"
                          style={{
                            fontSize: "14px",
                            color: "#4b5563",
                            lineHeight: "1.8",
                            paddingLeft: "20px",
                            margin: 0
                          }}
                        >
                          <li style={{ marginBottom: "8px" }}>📧 Você receberá uma confirmação do reembolso por email</li>
                          <li style={{ marginBottom: "8px" }}>🔔 Fique atento às nossas comunicações para novas datas</li>
                          <li style={{ marginBottom: "8px" }}>📞 Entre em contato conosco se tiver dúvidas</li>
                          {rescheduleLink && (
                            <li style={{ marginBottom: "8px" }}>
                              📅 <a href={rescheduleLink} style={{ color: "#3b65f5", textDecoration: "none" }}>
                                Clique aqui para reagendar para uma nova data
                              </a>
                            </li>
                          )}
                        </ul>
                      </div>

                      {/* Botão de Reagendamento */}
                      {rescheduleLink && (
                        <div style={{ textAlign: "center", marginBottom: "24px" }}>
                          <a
                            href={rescheduleLink}
                            className="btn btn-primary"
                            style={{
                              backgroundColor: "#3b65f5",
                              color: "#ffffff",
                              textDecoration: "none",
                              padding: "12px 24px",
                              borderRadius: "8px",
                              fontSize: "14px",
                              fontWeight: "bold",
                              display: "inline-block",
                              cursor: "pointer",
                              transition: "background-color 0.3s ease",
                              maxWidth: "100%",
                              boxSizing: "border-box"
                            }}
                          >
                            📅 Reagendar para Nova Data
                          </a>
                        </div>
                      )}

                      {/* Mensagem de Desculpas */}
                      <div
                        className="info-box"
                        style={{
                          background: "#f8fafc",
                          border: "1px solid #cbd5e1",
                          borderRadius: "10px",
                          padding: "20px",
                          marginBottom: "20px",
                          textAlign: "center"
                        }}
                      >
                        <h3 style={{ 
                          fontSize: "16px", 
                          color: "#1F1746", 
                          margin: "0 0 12px"
                        }}>
                          🙏 Nossas Sinceras Desculpas
                        </h3>
                        <p style={{ 
                          margin: 0, 
                          fontSize: "14px", 
                          color: "#4b5563",
                          lineHeight: "1.6"
                        }}>
                          Sabemos da importância desta formação para você e sua equipe. Estamos trabalhando para 
                          reagendar o mais breve possível e garantir que você tenha acesso ao conteúdo de qualidade 
                          que esperava. Agradecemos sua compreensão.
                        </p>
                      </div>

                      {/* Contato de suporte */}
                      <div
                        className="contact-box"
                        style={{
                          border: "1px solid #e5e7eb",
                          borderRadius: "10px",
                          padding: "18px",
                          background: "#ffffff",
                          margin: "20px 0",
                          textAlign: "center"
                        }}
                      >
                        <h2 
                          className="contact-title"
                          style={{ 
                            fontSize: "16px", 
                            color: "#111", 
                            margin: "0 0 10px"
                          }}
                        >
                          🤝 Precisa de ajuda? Entre em contato conosco:
                        </h2>
                        <p 
                          className="contact-info"
                          style={{ 
                            margin: 0, 
                            fontSize: "14px", 
                            color: "#374151", 
                            lineHeight: "1.6"
                          }}
                        >
                          ✉️ {supportEmail}
                          <br />📱 {supportPhone}
                        </p>
                      </div>
                    </td>
                  </tr>

                  {/* Footer */}
                  <tr>
                    <EmailFooterV2 variant="clean" showContactInfo={true} />
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  )
}
